'use strict';

(function () {
  'use strict';

  angular.module('vnext').component('msActionItemPlan', {
    templateUrl: 'sleep/templates/action-item-plan.html',
    controller: ActionItemPlanCtrl,
    controllerAs: 'vm',
    bindings: {
      hasSchedule: '<'
      /* <boolean> indicates whether user has sleep schedule */
    }
  });
  ActionItemPlanCtrl.$inject = ['actionPlanSvc', 'NotifyingSvc', '$timeout', 'eventTrackingSvc'];

  function ActionItemPlanCtrl(actionPlanSvc, NotifyingSvc, $timeout, eventTrackingSvc) {
    var vm = this;
    vm.$onInit = activate;
    vm.removeItem = removeItem;
    vm.undoRemoveItem = undoRemoveItem;
    vm.goToSleepActivities = goToSleepActivities;
    vm.toggleTip = toggleTip;

    var SLEEP_FOCUS = 'condition:insomnia';

    vm.removeDialogText = {
      init: 'sleep.checkInSimple.remove',
      undo: 'sleep.checkInSimple.undo'
    };

    ///////////////////////////////
    function activate() {
      actionPlanSvc.getMyPlan().then(function (actionItems) {
        vm.actionItems = actionItems;
        $timeout(function () {
          return NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.PRINT_HTTP_COMPLETE);
        });
      });
    }

    function removeItem(item) {
      eventTrackingSvc.fireEvent('sleepTool', 'removeFromPlanClick', item.title);
      return actionPlanSvc.removeFromPlan(item.id).then(function () {
        item.deleted = true;
      });
    }

    function undoRemoveItem(item) {
      return actionPlanSvc.addToPlan(item.id).then(function () {
        item.deleted = false;
      });
    }

    function goToSleepActivities() {
      NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.FOCUS_UPDATED, {
        focus: SLEEP_FOCUS
      });
    }

    function toggleTip(item) {
      item.showTip = !item.showTip;
      if (item.showTip) {
        eventTrackingSvc.fireEvent('sleepTool', 'actionItemMoreClick', item.title);
      }
    }
  }
})();